import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../hooks/useStores.tsx";
import styles from "./CustomerViewBanner.module.scss";

const CustomerViewBanner = () => {
	const { uiStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "CustomerViewBanner" });

	return (
		<>{uiStore.shouldDisplayCustomerViewBanner() && <Box className={styles.anouncementBar}>{t("title")}</Box>}</>
	);
};

export default observer(CustomerViewBanner);
